import React, { useEffect, useState } from "react";
import { heroSlides } from "../data/mock";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function HeroSlider({ onCtaClick }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroSlides.length), 5000);
    return () => clearInterval(t);
  }, []);

  const go = (n) => setIdx((idx + n + heroSlides.length) % heroSlides.length);
  const slide = heroSlides[idx];

  return (
    <section className="relative h-[70vh] md:h-[78vh] overflow-hidden bg-gray-100">
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className="absolute inset-0 hero-slide"
          style={{ opacity: i === idx ? 1 : 0, pointerEvents: i === idx ? "auto" : "none" }}
        >
          <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/25 to-transparent" />
        </div>
      ))}

      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 w-full">
          <div className="max-w-2xl text-white">
            <p className="text-sm md:text-base uppercase tracking-[0.3em] text-brand-red font-semibold mb-3">
              {slide.subtitle}
            </p>
            <h1 className="font-display text-4xl md:text-6xl font-bold leading-tight mb-6">
              {slide.title}
            </h1>
            <p className="text-base md:text-lg text-white/90 mb-7 max-w-xl">
              We are Manufacturer, Supplier, Wholesaler &amp; Trader of premium foam sheet products including memory foam, PU foam, EPE foam and more.
            </p>
            <div className="flex flex-wrap gap-3">
              <button onClick={onCtaClick} className="btn-red-brand px-7 py-3 rounded-md text-sm font-semibold">
                {slide.cta}
              </button>
              <a href="#products" className="px-7 py-3 rounded-md text-sm font-semibold border border-white/40 text-white hover:bg-white hover:text-brand-navy transition-colors">
                Browse Catalog
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Arrows */}
      <button onClick={() => go(-1)} className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 bg-white/15 hover:bg-white text-white hover:text-brand-navy w-11 h-11 rounded-full flex items-center justify-center transition-colors backdrop-blur-sm" aria-label="Prev">
        <ChevronLeft size={22} />
      </button>
      <button onClick={() => go(1)} className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 bg-white/15 hover:bg-white text-white hover:text-brand-navy w-11 h-11 rounded-full flex items-center justify-center transition-colors backdrop-blur-sm" aria-label="Next">
        <ChevronRight size={22} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            className={`h-2 rounded-full transition-all ${i === idx ? "w-8 bg-brand-red" : "w-2 bg-white/60 hover:bg-white"}`}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
